export interface IBookmark {
  uuid: string;
  type: string;
  data_uuid: string;
  note: string;
  created_at: string;
  updated_at: string;
}

export interface IBookmarkCompany extends IBookmark {
  name: string;
  country_name: string;
  country_code: string;
  registration_number: string;
  full_address: string;
  jurisdiction: string;
  is_stock: string;
  is_review: string;
  is_social_media: string;
  status: string;
  status_code: number;
}

export interface IBookmarkPeople extends IBookmark {
  name: string;
  position: string;
  position_code: string;
  company_uuid: string;
  company_name: string;
  country_name: string;
  country_code: string;
  jurisdiction: string;
  is_alerts: boolean;
  category: string[];
}
export interface IBookmarkTradeData extends IBookmark {
  hs_code: string;
  hs_code_description: string;

  start_date: string;
  end_date: string;

  exp_country_code: string;
  imp_country_code: string;
  exp_country_name: string;
  imp_country_name: string;

  supplier_id: string;
  buyer_id: string;
  supplier_name: string;
  buyer_name: string;

  exp_port_code: string;
  imp_port_code: string;

  hs_code_type: string;

  exp_port_name: string;
  imp_port_name: string;

  product_name: string;
}
export interface IBookmarkCompareCompany extends IBookmark {
  list_company_compare: Array<IBookmarkItemCompareCompany>;
}

export interface IBookmarkItemCompareCompany extends IBookmark {
  id: string;
  country_code: string;
  name: string;
}

export interface IBookmarkTradeDataRaw extends IBookmark {
  trade_data_info: IBookmarkTradeData;
}

export enum BookmarkTypes {
  Company = 'company',
  People = 'people',
  TradeData = 'trade_data',
  CompareCompany = 'compare_company',
}

export interface IBookmarkModelAndTypeMapping {
  [BookmarkTypes.Company]: IBookmarkCompany;
  [BookmarkTypes.People]: IBookmarkPeople;
  [BookmarkTypes.TradeData]: IBookmarkTradeData;
  [BookmarkTypes.CompareCompany]: IBookmarkCompareCompany;
}

export interface IBookmarkModelAndTypeMappingRaw {
  [BookmarkTypes.Company]: IBookmarkCompany;
  [BookmarkTypes.People]: IBookmarkPeople;
  [BookmarkTypes.TradeData]: IBookmarkTradeDataRaw;
  [BookmarkTypes.CompareCompany]: IBookmarkCompareCompany;
}

export interface IBookmarkCompanyCreatePayload {
  data_uuid: string;
}

export interface IBookmarkTradeDataCreatePayload extends Partial<IBookmarkTradeData> {}

export interface IBookmarkPeopleCreatePayload {
  data_uuid: string;
}

export interface IBookmarkCompareCreatePayload {
  company_ids: string[];
}

export interface IBookmarkCreateResponse {
  status_code: number;
  message: string;
}
